import { render, staticRenderFns } from "./DecorSet.vue?vue&type=template&id=2424e14d&scoped=true"
import script from "./DecorSet.vue?vue&type=script&lang=ts"
export * from "./DecorSet.vue?vue&type=script&lang=ts"
import style0 from "./DecorSet.vue?vue&type=style&index=0&id=2424e14d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2424e14d",
  null
  
)

export default component.exports